import * as React from 'react';
import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import { visuallyHidden } from '@mui/utils';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardActionArea, CardContent, Checkbox, Chip, Dialog, DialogActions, DialogContent, Divider, FormControl, Grid, InputAdornment, InputLabel, LinearProgress, ListItemText, MenuItem, OutlinedInput, Select, Stack, Switch, TextField } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { deleteSetting, getSetting, toggleActivation } from '../../store/settingSlice';
import GlobalSettingForm from './settings/GlobalSettingForm';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { ROWS_PER_PAGE } from '../../utils/constant';
import Loader from '../Common/Loader';
import ReadMoreArea from '@foxeian/react-read-more';
import Confirmation from '../Common/Confirmation';
import { NoData } from '../Common/NoData';
import ViewMorePopover from '../Common/ReadMoreLess';
import FilterListOffIcon from '@mui/icons-material/FilterListOff';


function createData(id, key, value, active, actions) {
    return {
        id,
        key,
        value,
        active,
        actions
    };
}

const SettingActions = ({ setRoleModal, setting, setSelectedRole, canEdit, fetchSetting }) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const [open, setOpen] = React.useState(false);


    const dispatch = useDispatch()
    const handleDelete = async (id) => {
        try {
            dispatch(deleteSetting(id))
        } catch (error) {
            console.error(error);
        }
    }
    console.log("canEdit", canEdit);

    return (
        <>
            <GlobalSettingForm openModal={open} setOpenModal={setOpen} fetchSetting={fetchSetting} selectedSetting={setting} title="Edit Setting" />
            <Grid spacing={4} justifyContent={'flex-end'}>
                <Grid size={8}>
                    <Box gap={2} display='flex' className="table-margin">
                        <EditOutlinedIcon className={`mr-1 ${!canEdit ? 'icon-disabled link-color' : 'link-color'}`} onClick={() => {
                            if (canEdit) {
                                setOpen(true);
                            }
                        }} />
                    </Box>
                </Grid>
            </Grid>
        </>
    )
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
    {
        label: 'Key',
        numeric: false,
        disablePadding: false,
        id: 'key',
        sortable: true
    },
    {
        label: 'Value',
        numeric: false,
        disablePadding: false,
        id: 'value',
        sortable: false
    },
    {
        label: 'Active',
        numeric: false,
        disablePadding: false,
        id: 'active',
        sortable: false
    },
    {
        label: 'Actions',
        numeric: false,
        disablePadding: false,
        id: 'actions',
        sortable: false
    },
];

function EnhancedTableHead(props) {
    const { setOrdering, orderingState, setOrderingState } =
        props;

    const createSortHandler = (property) => (event) => {
        const orderData = orderingState
        const exists = orderData?.find((item) => item.id === property);
        const updated = (() => {

            if (exists) {
                return orderData.map((item) =>
                    item.id === property
                        ? { ...item, order: item.order === "asc" ? "desc" : "asc" }
                        : item
                );
            } else {
                return [...orderData, { id: property, order: "asc" }];
            }
        })();
        setOrderingState(updated)
    };

    React.useEffect(() => {
        const ordering = orderingState.map((item) => {
            return item.order === "asc" ? item.id : "-" + item.id;
        });
        if (ordering?.length) {
            setOrdering(ordering.join(","));
        }
        console.log("orderingState", orderingState);

    }, [orderingState]);

    const removeFilter = (property) => {
        const data = orderingState.filter((item) => item.id !== property)
        setOrderingState(data)
    }

    return (
        <TableHead>
            {/* <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        className='font-weight'
                        key={headCell.id}
                        align={headCell.numeric ? 'left' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        {headCell.sortable ?
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                                color='secondary'
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                    </Box>
                                ) : null}
                            </TableSortLabel> : headCell.label}
                    </TableCell>
                ))}
            </TableRow> */}
            <TableRow>
                {headCells.map((headCell) => {
                    const key = headCell.id;
                    const sortObj = orderingState.find((item) => item.id === key);
                    const isSorted = !!sortObj;
                    const sortDirection = sortObj?.order || "asc";

                    return (<TableCell
                        className="font-weight"
                        key={key}
                        align={headCell.numeric ? "left" : "left"}
                        padding={headCell.disablePadding ? "none" : "normal"}
                        sortDirection={isSorted ? sortDirection : false}
                    >
                        {headCell.sortable ? <TableSortLabel
                            active={isSorted}
                            direction={sortDirection}
                            onClick={createSortHandler(key)}
                            color="secondary"
                            hideSortIcon={false}
                        >
                            {headCell.label}
                            {isSorted && (
                                <Box component="span" sx={visuallyHidden}>
                                    {sortDirection === "desc" ? "sorted descending" : "sorted ascending"}
                                </Box>
                            )}
                            {isSorted && <FilterListOffIcon onClick={(e) => { e.stopPropagation(); removeFilter(headCell.id) }} className="ml-2" size="small" color='primary' />}
                        </TableSortLabel> : headCell.label}
                    </TableCell>)
                })}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};
function EnhancedTableToolbar(props) {
    const dispatch = useDispatch()
    const [open, setOpen] = React.useState(false)
    const { page, setPage, fetchSetting, numSelected, resetTrigger, setResetTrigger } = props;

    return (
        <>
            <GlobalSettingForm page={page} setPage={setPage} fetchSetting={fetchSetting} openModal={open} setOpenModal={setOpen} title="Create Setting" resetTrigger={resetTrigger} />
            {/* <Toolbar
                className='main-list-toolbar'
            > */}
            <Typography
                className="d-flex flex-grow-1 flex-shrink-1 flex-fill mt-3"
                variant="h6"
                id="tableTitle"
                component="div"
            >
                Global Settings
            </Typography>
            {/* </Toolbar> */}
        </>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

export default function SettingsManage() {
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('calories');
    const [selected, setSelected] = React.useState([]);
    const [selectedSetting, setSelectedSetting] = React.useState([]);
    const [rows, setRows] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [opneActiveConfirm, setOpneActiveConfirm] = React.useState(false);
    const [rowsPerPage, setRowsPerPage] = React.useState(ROWS_PER_PAGE);
    const [roleModal, setRoleModal] = React.useState(false);
    const [selectedRole, setSelectedRole] = React.useState({});
    const dispatch = useDispatch()
    const [queryString, setQueryString] = React.useState("");

    const settingsData = useSelector((state) => state.settingReducer.settingsData)
    const count = useSelector((state) => state.settingReducer.count)
    const loading = useSelector((state) => state.settingReducer.loading)
    const [resetTrigger, setResetTrigger] = React.useState(false);
    const userPermission = useSelector((state) => state.userReducer.userPermission)
    const settingPermissions = userPermission.find((perm) => perm.model_name === "globalsetting")?.permissions || [];
    const [ordering, setOrdering] = React.useState('-created_at');
    const [orderingState, setOrderingState] = React.useState([])

    let canEdit = settingPermissions.includes("change");
    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = rows.map((n) => n.id);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    console.log("rows", rows);


    React.useEffect(() => {
        const label = { inputProps: { 'aria-label': 'Color switch demo' } };
        const rowData = settingsData?.map((ele) => createData(ele.id, ele.key, ele?.value, <Switch disabled={loading} className={`${!canEdit && 'icon-disabled'}`} checked={ele.deactivated_on ? false : true} {...label} onClick={(e) => {
            if (canEdit) {
                setSelectedSetting(ele)
                if (!ele?.deactivated_on) {
                    setOpneActiveConfirm(true)
                } else {
                    dispatch(toggleActivation(ele.uuid))
                }
            }
        }} />, <SettingActions {...{ fetchSetting, setRoleModal, setSelectedRole, canEdit }} setting={ele} />))
        setRows(rowData)
    }, [settingsData, loading])

    // const visibleRows = React.useMemo(() => {
    //     console.log(rows, "rows memo");

    //     return [...rows]

    // }, [rows]);
    React.useEffect(() => {
        console.log("rows updated", rows);
    }, [rows]);


    // React.useEffect(() => {
    //     dispatch(getSetting("?ordering=" + ordering));
    // }, [ordering])

    React.useEffect(() => {
        console.log("page", page);
        console.log("rowsPerPage", rowsPerPage);

        setQueryString(`?page=${page + 1}&page_size=${rowsPerPage}&ordering=${ordering}`)
    }, [ordering, page, rowsPerPage])

    const fetchSetting = () => {
        dispatch(getSetting(queryString))
    }

    React.useEffect(() => {
        if (queryString) {
            fetchSetting(queryString)
        }
    }, [queryString])

    return (
        <Box className='w-100'>
            <Confirmation open={opneActiveConfirm} setOpen={setOpneActiveConfirm} msg="Are you sure you want to Inactive this Setting" yesClick={() => { dispatch(toggleActivation(selectedSetting.uuid)); setOpneActiveConfirm(false) }} />
            <Paper className="w-100 mb-2" >
                <EnhancedTableToolbar numSelected={selected.length} {...{ page, setPage, fetchSetting, resetTrigger, setResetTrigger }} />
                {loading && <LinearProgress />}
                <TableContainer className='position-relative mt-3'>
                    <Table
                        container
                        className='min-width-750'
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        <EnhancedTableHead
                            numSelected={selected?.length}
                            orderingState={orderingState}
                            setOrderingState={setOrderingState}
                            setOrdering={setOrdering}
                            onSelectAllClick={handleSelectAllClick}
                            onRequestSort={handleRequestSort}
                            rowCount={rows?.length}
                        />
                        <TableBody>
                            {rows?.map((row, index) => {
                                const isItemSelected = selected.includes(row.id);
                                console.log(row, "rows");

                                return (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        aria-checked={isItemSelected}
                                        tabIndex={-1}
                                        key={row.id}
                                        selected={isItemSelected}
                                        className='cursor-pointer'>
                                        <TableCell align="left">
                                            <Tooltip title="This message will be used as an auto-reply when contact information from the domain is restricted from being shared.">
                                                {row.key}
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="left">
                                            {/* <ReadMoreArea className="custom-read-more"
                                                lettersLimit={50}>
                                                {row.value}
                                            </ReadMoreArea> */}
                                            {row.value && row.value.slice(0, 100)}
                                            {row.value && row.value.length > 100 && (
                                                <ViewMorePopover>
                                                    <div>{row.value}</div>
                                                </ViewMorePopover>
                                            )}
                                        </TableCell>
                                        <TableCell align="left">
                                            {row.active}
                                        </TableCell>
                                        <TableCell align="left">{row.actions}</TableCell>
                                    </TableRow>
                                );
                            })}
                        </TableBody>
                    </Table>
                    {!settingsData?.length && !loading && <NoData></NoData>}
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={count}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box >
    );
}
